module.exports = "/static/media/lineto-circular-book.0415b07a.woff2";